// src/components/charts/PlatformTotalsBar.jsx
import React from 'react';
import {
  ResponsiveContainer, BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip,
} from 'recharts';

/**
 * Sort `groupBy=platform` buckets by count desc. Null/empty key → "Senza piattaforma".
 * Exported for unit testing.
 */
export function platformRows(stats) {
  if (!stats?.buckets) return [];
  return [...stats.buckets]
    .map(b => ({
      platform: b.key == null || b.key === '' ? 'Senza piattaforma' : b.key,
      count: b.count || 0,
    }))
    .sort((a, b) => b.count - a.count);
}

export default function PlatformTotalsBar({ data }) {
  const rows = platformRows(data);
  if (rows.length === 0) return null;
  return (
    <ResponsiveContainer width="100%" height={Math.max(180, rows.length * 32 + 40)}>
      <BarChart data={rows} layout="vertical" margin={{ top: 8, right: 24, bottom: 8, left: 8 }}>
        <CartesianGrid strokeDasharray="3 3" stroke="rgba(0,0,0,0.06)" horizontal={false} />
        <XAxis type="number" allowDecimals={false} tick={{ fontSize: 11, fill: '#6c6c6d' }} />
        <YAxis type="category" dataKey="platform" width={120} tick={{ fontSize: 11, fill: '#1d1d1f' }} />
        <Tooltip contentStyle={{ fontSize: 12, fontFamily: "'DM Sans', sans-serif" }} />
        <Bar dataKey="count" fill="#1d1d1f" />
      </BarChart>
    </ResponsiveContainer>
  );
}
